<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <wf-consumer-corp-recharge-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></wf-consumer-corp-recharge-form>
  </j-modal>
</template>

<script>

  import WfConsumerCorpRechargeForm from './WfConsumerCorpRechargeForm'
  export default {
    name: 'WfConsumerCorpRechargeModal',
    components: {
      WfConsumerCorpRechargeForm
    },
    data () {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (model) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add(model);
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>